<!--
* @Name：供应商营业业绩
* @Author: 王超
* @Date: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in suppInfoList" :key="item.infoPk" :row-index="index + 1">
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>联系人：</span>
        <span>{{ item.linkMan }}</span>
      </van-row>
      <van-row>
        <span>手机：</span>
        <span>{{ item.mobilePhone }}</span>
      </van-row>
      <van-row>
        <span>办公电话：</span>
        <span>{{ item.telephone }}</span>
      </van-row>
      <van-row>
        <span>电子邮箱：</span>
        <span>{{ item.email }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'bidSuppList',
  data() {
    return {}
  },
  props: {
    suppInfoList: {
      type: Array,
      required: true
    }
  },
  computed: {
    enterpriseTypeDictOptions() {
      return this.$store.getters.dicts.enterprise_character
    },
    quoteStatusDictOptions() {
      return this.$store.getters.dicts.quote_status
    }
  }
}
</script>
